module.exports = __webpack_public_path__ + "img/clone-inactive.67abfc27.svg";